import React from 'react'
import { Shimmer, SkeletonElement } from '..'

const SkeletonImages: React.FC = () => {
  return (
    <div className='mb-3 w-full mx-auto items-center bg-[#f2f2f2] shadow-sm p-4 lg:mb-0 rounded flex flex-col overflow-hidden relative'>
      <div className="flex w-full mx-auto justify-between items-center mb-3">
        <div className="flex w-[70%] gap-2">
          <SkeletonElement type="menu" />
          <div className="w-[70%]">
            <SkeletonElement type="title"/>
            <div className="flex w-[50%] gap-1 items-center">
              <SkeletonElement type="title"/>
              <SkeletonElement type="title"/>
            </div>
          </div>
        </div>
        <SkeletonElement type='icon'/>
      </div>
      <SkeletonElement type='image'/>
      <Shimmer/>
    </div>
  )
}

export default SkeletonImages